import { apiURL, baseWebinarURLV1, baseWebinarURLV2 } from "../utils/Constants";

export const getEvents = async () => {
    const requestOptions = {
        method: "GET",
        headers: expressHeaders(),
        credentials: "include" as RequestCredentials,
    };

    const res: Response = await fetch(`${apiURL}webinar/list`, requestOptions);
    if (!res.ok) {
        return [];
    }
    return await res.json();
};

export const getWebinars = async (orgKey: string, channel: string) => {
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    const accessToken = tokens.access_token;
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${accessToken}`);

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
    };

    const fromTime = new Date();
    const toTime = new Date(fromTime);
    toTime.setDate(toTime.getDate() + 3);

    const res: Response = await fetch(`${baseWebinarURLV1}organizers/${orgKey}/upcomingWebinars`, requestOptions);
    if (!res.ok) {
        return [];
    }
    return await res.json();
};

export const getWebinarByID = async (id: string) => {
    const requestOptions = {
        method: "GET",
        headers: expressHeaders(),
        credentials: "include" as RequestCredentials,
    };

    const res: Response = await fetch(`${apiURL}webinar/${id}`, requestOptions);
    if (!res.ok) {
        return null;
    }
    return await res.json();
};

export const getWebinarRegistrants = async (orgKey: string, id: string) => {
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    const accessToken = tokens.access_token;
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${accessToken}`);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
    };

    const res: Response = await fetch(`${baseWebinarURLV2}organizers/${orgKey}/webinars/${id}/registrants`, requestOptions);
    return res;
};

export const getWebinarFields = async (orgKey: string, id: string) => {
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    const accessToken = tokens.access_token;
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${accessToken}`);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
    };

    const res: Response = await fetch(`${baseWebinarURLV2}organizers/${orgKey}/webinars/${id}/registrants/fields`, requestOptions);
    return res;
};

export const registerUserInWebinar = async (orgKey: string, idWebinar: string, payload) => {
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    const accessToken = tokens.access_token;
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${accessToken}`);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
    };

    const res: Response = await fetch(
        `${baseWebinarURLV1}organizers/${orgKey}/webinars/${idWebinar}/registrants?resendConfirmation=true`,
        requestOptions,
    );
    return res;
};

export const setWebinarActive = async (id: string, active: boolean) => {
    const requestOptions = {
        method: "PUT",
        headers: expressHeaders(),
        body: JSON.stringify({ active }),
        credentials: "include" as RequestCredentials,
    };

    const res: Response = await fetch(`${apiURL}webinar/${id}/active`, requestOptions);
    if (!res.ok) {
        return {
            status: false,
            message: "Errore durante l'aggiornamento dello stato",
        };
    }
    return await res.json();
};

export const saveUser = async (payload: any) => {
    const requestOptions = {
        method: "POST",
        headers: expressHeaders(),
        body: JSON.stringify(payload),
        credentials: "include" as RequestCredentials,
    };

    const res: Response = await fetch(`${apiURL}user`, requestOptions);
    return res;
};

export const saveWebinar = async (payload: any) => {
    const requestOptions = {
        method: "POST",
        headers: expressHeaders(),
        body: JSON.stringify(payload),
        credentials: "include" as RequestCredentials,
    };

    const res: Response = await fetch(`${apiURL}webinar`, requestOptions);

    if (!res.ok) {
        return {
            status: false,
            message: "Errore durante il salvataggio",
        };
    }
    return await res.json();
};

export const deleteUser = async (userID: string) => {
    const requestOptions = {
        method: "DELETE",
        headers: expressHeaders(),
        credentials: "include" as RequestCredentials,
    };

    const res: Response = await fetch(`${apiURL}user/${userID}`, requestOptions);
    if (!res.ok) {
        return {
            status: false,
            message: "Errore durante l'eliminazione",
        };
    }
    return await res.json();
};

export const getUsersByWebinar = async (webinarID: string, consent: string = "-1") => {
    const requestOptions = {
        method: "GET",
        headers: expressHeaders(),
        credentials: "include" as RequestCredentials,
    };

    const res: Response = await fetch(`${apiURL}user/queue-in-webinar/${webinarID}`, requestOptions);
    if (!res.ok) {
        return {
            status: false,
            message: "",
        };
    }
    return await res.json();
};

export const getAreas = async () => {
    const requestOptions = {
        method: "GET",
        headers: expressHeaders(),
        credentials: "include" as RequestCredentials,
    };

    const res: Response = await fetch(`${apiURL}webinar/thematic-area`, requestOptions);
    if (!res.ok) {
        return {
            status: false,
            message: "",
        };
    }
    return await res.json();
};

export const expressHeaders = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", `application/json`);
    return myHeaders;
};
